import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../pages/main.reducer";
import { CHANGE_DARK_MODE, SET_ZOOM, SET_CURRENCY, SET_CONVERSION_RATE } from "./common.actions";
import { Currency } from "./constants";
import { getConversionRateApi } from "./api/getConversionRateApi";

export const useCommon = () => {
  const zoom = useSelector<AppState, number>(store => store.common.zoom);
  const darkMode = useSelector<AppState, boolean>(store => store.common.darkMode);
  const currency = useSelector<AppState, Currency>(store => store.common.currency);
  const conversionRate = useSelector<AppState, number>(store => store.common.conversionRate);

  const dispatch = useDispatch();

  const setZoomAction = (zoom: number) => dispatch({ type: SET_ZOOM, zoom });
  const setDarkMode = (darkMode: boolean) => dispatch({ type: CHANGE_DARK_MODE, darkMode });

  const setCurrency = (currency: Currency) => {
    dispatch({ type: SET_CURRENCY, currency });
    localStorage.setItem("bpb.currency", currency);
  };

  const setConversionRate = (rate: number) => {
    dispatch({ type: SET_CONVERSION_RATE, conversionRate: rate });
  };

  const zoomMax = window.innerWidth > 540 ? 5 : 2;
  const zoomMin = window.innerWidth > 540 ? 2 : 1;

  const setZoom = (zoom: number) => {
    const newZoom = zoom > zoomMax ? zoomMax : (zoom < zoomMin ? zoomMin : zoom);
    setZoomAction(newZoom);
    localStorage.setItem("bpb.zoom", newZoom.toString());
  }

  const getLocalDarkMode = (): boolean => {
    const storageString = localStorage.getItem("bpb.darkMode");
    return storageString ? JSON.parse(storageString) : false;
  }

  useEffect(() => {
    setDarkMode(getLocalDarkMode());

    // Fetch conversion rate from backend
    getConversionRateApi(dispatch).then((success) => {
      if (!success) {
        // If conversion rate is unavailable, force currency to DIN
        dispatch({ type: SET_CURRENCY, currency: "DIN" });
        localStorage.setItem("bpb.currency", "DIN");
        return;
      }

      // Load saved currency or auto-detect via geolocation
      const savedCurrency = localStorage.getItem("bpb.currency");
      if (savedCurrency === "DIN" || savedCurrency === "KM") {
        dispatch({ type: SET_CURRENCY, currency: savedCurrency });
      } else {
        fetch("https://ipapi.co/country_code/")
          .then((res) => res.text())
          .then((countryCode) => {
            if (countryCode.trim() === "BA") {
              dispatch({ type: SET_CURRENCY, currency: "KM" });
              localStorage.setItem("bpb.currency", "KM");
            }
          })
          .catch(() => { /* Default DIN is fine */ });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    zoom,
    setZoom,
    darkMode,
    setDarkMode,
    zoomMax,
    zoomMin,
    currency,
    setCurrency,
    conversionRate,
    setConversionRate,
  }
}